import { useEffect, useState } from "react";
import { loadZens } from "../data/loadZens";

export function useZenTitles(limit = 4) {
  const [zenTitles, setZenTitles] = useState([]);

  useEffect(() => {
    loadZens().then((data) => {
      const trimmed = data.slice(0, limit);
      setZenTitles(trimmed.map(z => ({
        title: z.title,
        slug: z.slug
      })));
    });
  }, [limit]);

  return zenTitles;
}
